import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, Flex, Heading, Select } from '@chakra-ui/react';
import { RefreshCw } from 'lucide-react';
import { useDispatch, useSelector } from 'react-redux';
import axios from 'axios';
import GenericTable from '../components/GenericTable';
import { getGames } from '../actions/gameActions';

const DrawsByGame = () => {
  const dispatch = useDispatch();
  const { games } = useSelector(state => state.game);

  const [selectedGame, setSelectedGame] = useState('');
  const [draws, setDraws] = useState([]);
  const [refreshing, setRefreshing] = useState(false);

  useEffect(() => {
    dispatch(getGames());
  }, [dispatch]);

  const fetchDraws = useCallback(async () => {
    if (!selectedGame) {
      setDraws([]);
      return;
    }
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL_ADMIN}`, {
        apiName: 'draw',
        command: 'getDrawsByGameId',
        gameId: selectedGame,
      });
      setDraws(response.data.data || []);
    } catch (error) {
      setDraws([]);
    }
  }, [selectedGame]);

  useEffect(() => {
    fetchDraws();
  }, [fetchDraws]);

  const handleRefresh = async () => {
    setRefreshing(true);
    try {
      await Promise.all([dispatch(getGames()), fetchDraws()]);
    } finally {
      setRefreshing(false);
    }
  };

  const columns = [
    { Header: 'Draw ID', accessor: 'draw_id' },
    { Header: 'Game', accessor: 'game_name' },
    { Header: 'Draw Time', accessor: 'draw_time', Cell: ({ value }) => new Date(value).toLocaleString() },
    { Header: 'Result', accessor: 'result', Cell: ({ value }) => value || '-' },
    { Header: 'Bonus', accessor: 'bonus', Cell: ({ value }) => value || '-' },
  ];

  return (
    <Box>
      <Flex justify="space-between" align="center" mb={4} gap={3} wrap="wrap">
        <Heading size="lg">Draws By Game</Heading>
        <Button
          leftIcon={<RefreshCw size={16} />}
          colorScheme="blue"
          variant="outline"
          onClick={handleRefresh}
          isLoading={refreshing}
          loadingText="Refreshing"
        >
          Refresh
        </Button>
      </Flex>
      <Select
        placeholder="Select Game"
        mb={4}
        value={selectedGame}
        onChange={(e) => setSelectedGame(e.target.value)}
      >
        {games && games.map(game => (
          <option key={game._id} value={game._id}>{game.name}</option>
        ))}
      </Select>
      <GenericTable columns={columns} data={draws} initialPageSize={50} />
    </Box>
  );
};

export default DrawsByGame;
